<template>
	<div id="body">
		<div class="title">
			<i class="bi bi-person-dash"></i> 会员注册
		</div>
		
		<div id="info">请选择您的注册方式</div>
		
		<a href="registerEnterprise">
			<div class="item">
				<div class="item-text">
					<i class="el-icon-s-custom"></i> 企业会员
				</div>
			</div>
		</a>
		
		<a href="registerIndividual">
			<div class="item1">
				<div class="item-text">
					<i class="el-icon-user-solid"></i> 个人会员
				</div>
			</div>
		</a>
	</div>
</template>

<script>
	export default {
	  name: "registerHome",
	  data() {
		return {
			text:''
		};
	  },
	  methods: {
		  
	  },
	};
</script>

<style scoped="scoped">
	.item{
		border-radius: 4px;
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.2);
		height: 6.5rem;
		width: 90%;
		text-align: center;
		margin: 0 auto;
		margin-top: 11%;
		background: url(../assets/59f5bf4e3d197.jpg);
		background-size: 100% 100%;
	}
	
	.item1{
		border-radius: 4px;
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.2);
		height: 6.5rem;
		width: 90%;
		text-align: center;
		margin: 0 auto;
		margin-top: 11%;
		background: url(../assets/59f5bf4e3d04b.jpg);
		background-size: 100% 100%;
	}
	
	.item-text{
		font-family: "Hiragino Sans GB","微软雅黑",Arial,sans-serif;
		padding-top: 12%;
		margin-right: 200px;
		color: #009688;
	}
	
	#info{
		margin-top: 30%;
		text-align: center;
	}
	
	a{
		text-decoration: none;
	}
</style>
